<div class="slide-popup-backdrop" [class.open]="isOpen" (click)="closePopup()"></div>

<div class="slide-popup-container" [class.open]="isOpen">
  <div class="support-dialog">

    <!-- Header -->
    <div class="dialog-title-container">
      <div class="dialog-title-text">{{'menu.help.lbl_support' | translate}}</div>
    </div>

    <!-- Body -->
    <div class="tab-container app-dark-bg">
      <div class="tab-forms app-light-bg">
        <div *ngIf="!isSubmitted" class="ft-form-row">
          <span class="title">{{'more_help.contact_form.lbl_title' | translate}}</span>
        </div>
        <div class="ft-form support-form-container">
          <div *ngIf="isSubmitted" class="success-message-container">
            <p [innerHTML]="responseMessage"></p>
            <button type="button" class="ft-btn ft-btn-active" (click)="closePopup()">
              {{ 'lbl_close' | translate }}
            </button>
          </div>
          <form *ngIf="!isSubmitted" [formGroup]="supportForm" (ngSubmit)="onSubmit()" enctype="multipart/form-data"
            autocomplete="off">
            <!-- Name & Email -->
            <div class="ft-form-row col2-v50v50">
              <div class="ft-form-input">
                <label for="name">{{'more_help.contact_form.lbl_name' | translate}}</label>
                <input type="text" id="name" formControlName="name" [ngClass]="{'border-danger': isValid('name')}"
                  placeholder="{{'more_help.contact_form.lbl_name' | translate}}" />
                <span [class.invisible]="!isValid('name')" class="text-danger">
                  {{'more_help.contact_form.errors.lbl_name' | translate}}
                </span>
              </div>
              <div class="ft-form-input">
                <label for="email">{{'more_help.contact_form.lbl_email' | translate}}</label>
                <input type="email" id="email" formControlName="email" [ngClass]="{'border-danger': isValid('email')}"
                  placeholder="{{'more_help.contact_form.lbl_email' | translate}}" />
                <span [class.invisible]="!isValid('email')" class="text-danger">
                  {{'more_help.contact_form.errors.lbl_email' | translate}}
                </span>
              </div>
            </div>

            <!-- Subject --->
            <div class="ft-form-row col1-v100">
              <div class="ft-form-input">
                <label for="subject">{{'more_help.contact_form.lbl_subject' | translate}}</label>
                <input type="text" id="subject" formControlName="subject"
                  [ngClass]="{'border-danger': isValid('subject')}"
                  placeholder="{{'more_help.contact_form.lbl_subject' | translate}}" />
                <div [class.invisible]="!isValid('subject')" class="text-danger">
                  {{ ('more_help.contact_form.errors.lbl_subject' + (supportForm.get('subject')?.errors?.maxlength ?
                  '_length' : '')) | translate }}
                </div>
              </div>

              <div class="ft-form-input">
                <label for="category">{{'more_help.contact_form.lbl_category' | translate}}</label>
                <select id="category" formControlName="category"
                  [ngClass]="{'black-text': supportForm.get('category')?.value, 'border-danger': isValid('category')}">
                  <option value="" disabled hidden>{{'more_help.contact_form.lbl_select_category' | translate}}</option>
                  <option *ngFor="let category of categories" [value]="category.name">{{category.name}}</option>
                </select>
                <div [class.invisible]="!isValid('category')" class="text-danger">
                  {{'more_help.contact_form.errors.lbl_category' | translate}}
                </div>
              </div>
            </div>


            <!-- Message -->
            <div class="ft-form-row col1-v100">
              <div class="ft-form-input">
                <label for="message">{{'more_help.contact_form.lbl_message' | translate}}</label>
                <textarea id="message" rows="4" formControlName="message"
                  [ngClass]="{'border-danger': isValid('message')}"
                  placeholder="{{'more_help.contact_form.lbl_type_message' | translate}}"></textarea>
                <div [class.invisible]="!isValid('message')" class="text-danger">
                  {{('more_help.contact_form.errors.lbl_message' +
                  (supportForm.get('message')?.errors?.maxlength ?'_length' : '')) | translate }}
                </div>
              </div>
            </div>

            <!-- Attachment -->
            <div class="ft-form-row col1-v100">
              <div class="ft-form-input">
                <label>{{'more_help.contact_form.lbl_attachment' | translate}}</label>
                <label for="attachment" class="btn choose-file w-100"
                  [ngClass]="{'disabled': isFileLimitReached, 'border-danger': fileErrorKey != ''}">
                  {{'more_help.contact_form.lbl_choose_file' | translate}}
                </label>
                <input type="file" id="attachment" class="d-none" (change)="onFileChange($event)"
                  [disabled]="isFileLimitReached" multiple>
                <small class="form-text text-start note">
                  {{('more_help.contact_form.attachment_note.lbl_formats' | translate) + allowedFileTypesString + '. ' +
                  ('more_help.contact_form.attachment_note.lbl_max_size' | translate) + maxFileSizeString}}
                </small>
                <div [class.invisible]="fileErrorKey == ''" class="text-danger mt-2">{{fileErrorKey | translate}}</div>

                <ul class="file-list list-group mt-4" [ngClass]="{'d-none': selectedFiles.length == 0}">
                  <li class="file-container list-group-item w-100" *ngFor="let file of selectedFiles; let i = index">
                    <span class="file-name ms-2">{{ getFileNameWithoutExtention(file.name) }}.{{
                      getFileExtension(file.name) }}</span>
                    <button class="remove-button" type="button" (click)="removeFile(i)">&#10006;</button>
                  </li>
                </ul>
              </div>
            </div>
          </form>
        </div>

      </div>
      <div *ngIf="!isSubmitted" class="footer app-dark-bg">
        <button type="submit" class="ft-btn" [ngClass]="supportForm.valid ? 'ft-btn-active' : 'ft-btn-inactive'"
          [disabled]="!supportForm.valid" (click)="onSubmit()">
          {{ 'more_help.contact_form.lbl_send' | translate }}
        </button>
        <button type="button" class="ft-btn ft-btn-active-not-selected" (click)="closePopup()">
          {{ 'more_help.contact_form.lbl_cancel' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>